import styled from 'styled-components';

const Section = styled.section`
  position: relative;
  padding: 30px 0px;
  width: 100%;
  height: auto;
`;

export default Section;
